import { useEffect } from 'react'
import AppRoutes from '@/routes'
import AppErrorBoundary from '@/components/common/AppErrorBoundary'
import { Toaster } from 'react-hot-toast'
import { useAppDispatch } from '@/hooks/useAppDispatch'
import { fetchCurrentUser, selectTenant } from '@/features/auth/authSlice'
import { useAppSelector } from '@/hooks'
import { loadServerSkin } from '@/theme/skin'
import { useWebSocket } from '@/hooks/useWebSocket'
import { useHostTenant } from '@/features/auth/useHostTenant'

/**
 * Root application component
 *
 * Enhancements completed:
 * - ✅ React Router (Task 5.4)
 * - ✅ Redux Provider (Task 5.5)
 * - ✅ API Client (Task 5.6)
 * - ✅ Category Management UI (Task 6.1)
 * - ✅ WebSocket Integration (Task 7.9)
 * - ✅ Real-Time Updates (Task 7.9)
 */
export default function App() {
  const dispatch = useAppDispatch()

  // Initialize WebSocket connection for real-time updates
  useWebSocket()

  // On a workspace host (riverbend.graphit.io), make that workspace current
  // once the session is verified. A no-op on the app host.
  useHostTenant()

  // Check if user is already authenticated on app load
  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch])

  // The interface theme is per organization: ask again when it changes
  // (sign-in, switching organizations). The first answer comes from main.jsx.
  const tenantId = useAppSelector(selectTenant)?.id
  useEffect(() => {
    if (tenantId) loadServerSkin()
  }, [tenantId])

  return (
    <>
      <AppErrorBoundary name="root">
        <AppRoutes />
      </AppErrorBoundary>
      <Toaster position="top-right" toastOptions={{ className: 'graphit-toast' }} />
    </>
  )
}
